import { create } from 'zustand';
// API base path from environment variable, defaults to empty string for relative paths
const API_BASE_PATH = process.env.REACT_APP_RESOAPI_BASE_URL || "";

const useDropdownStore = create((set) => ({
  metadata: null,
  loading: false,
  error: null,

  fetchMetadata: async () => {
    set({ loading: true, error: null });

    try {
      const response = await fetch(`${API_BASE_PATH}/api/Options/getmore?mlsprovider=GAMLS`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const formattedData = JSON.parse(data.Data.propertytype);
      set({ metadata: formattedData, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  }
}));
export default useDropdownStore;
